/**
 * 数据监控 监控查询
 */
<template>
<div style="display: flex">
  <el-card class="box-card" style="width: 300px; margin-right: 10px">
					   <div slot="header" class="clearfix">
					      <span>项目</span>
					    </div>
			        <el-scrollbar style="height: 640px">
			          <el-tree
			            ref="tree"
			            :data="treeData"
			            node-key="FItemID"
			            :expand-on-click-node="false"
			            highlight-current
			            @node-click="nodeClick"
			          ></el-tree>
			        </el-scrollbar>
			      </el-card>
				  <el-card class="box-card" style="width: 300px; margin-right: 10px" v-if='showtable'>
					  <div slot="header" class="clearfix">
					     <span>模块明细类</span>
					   </div>
					 <!-- <el-tooltip class="item" effect="dark" content="新增大类" placement="top-start">
					  <el-button @click="navMenuInsert() " size="small" type="primary" icon="el-icon-plus" circle plain>
					  </el-button>
					 </el-tooltip>
					  <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
					  <el-button size="small" type="primary" icon="el-icon-edit" circle plain>
					  </el-button>
					  </el-tooltip> -->
				    <el-scrollbar style="height: 640px;margin-top: 10px;">
				    <el-tree
				      :props="props"
				      :load="loadNode"
				      lazy
					   ref="lazytree"
				      show-checkbox
				      @check-change="handleCheckChange"
					  @check="checkBox">
					   <!-- <span class="custom-tree-node" slot-scope="{ node, data }">
						<span>{{ node.label }}</span>
						<span>
						<el-button
							type="text"
							size="mini"
							@click="() => append(data)">
							添加下级
						</el-button>
					    <el-button
							type="text"
							size="mini"
							@click="() => remove(node, data)">
							Delete
						</el-button>
						</span>
					</span> -->
				    </el-tree>
				    </el-scrollbar>
				  </el-card>
			      <el-card class="box-card" style="flex: 1"> 
				    <div slot="header" class="clearfix" v-if='showtable'>
				   <span>清单列表</span>
				 </div>
               <el-dialog title="修改" :visible.sync="dialogFormVisible" v-if='dialogFormVisible' >
	                 <el-form :inline="true" :model="formInline" class="demo-form-inline">
						<el-form-item label="单据编号">
							<el-input v-model="formInline1.BIllNo" placeholder="单据编号"></el-input>
						</el-form-item>
						<el-form-item label="单据日期">
							<el-date-picker
							v-model="formInline1.value1"
							type="date"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="部门">
						<el-select v-model="formInline1.DepartmentID" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;">
						<el-option v-for="item in Departmentdata" :key="item.FItemID" :value-key="item.FItemID"
							:label="item.FName" :value="item.FItemID">
							<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
							</span>
						</el-option>
					</el-select>
						</el-form-item>
						<el-form-item label="制单人">
							<el-select v-model="formInline1.user" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;" disabled>
						<el-option v-for="item in userdata" :key="item.FUserID" :value-key="item.FUserID"
							:label="item.FName" :value="item.FUserID">
							<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
							</span>
						</el-option>
					</el-select>
						</el-form-item>
						</el-form>
			           <el-table ref="multipleTable" :data="UpdateData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" border id="el-table" highlight-current-row    v-loading="loading" 
						 element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;" class="demo-ruleForm">
						 <el-table-column align="center" width="100" >
							 <template slot-scope="scope">
								<span class="demo-ruleForm">
							 <el-tooltip class="item" effect="dark" content="新增行" placement="top-start" style="margin-top:5px">
						<el-button @click="ainsert(scope.row,scope.$index) " size="small" type="primary" icon="el-icon-plus" circle plain>
						</el-button>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="删除行" placement="top-start" style="margin-top:5px">
						<el-button @click="adelete(scope.row,scope.$index) " size="small" type="danger" icon="el-icon-delete" circle plain>
						</el-button>
						</el-tooltip>
						</span>
						</template>
						</el-table-column>
						<el-table-column align="center" sortable prop="FMaterialID" label="物料编码" >
								<template slot-scope="scope">
								<span class="demo-ruleForm">
									<el-select v-model="scope.row.FMaterialID" clearable filterable placeholder=" "
										style="display: block;" size="small"
										:filter-method="filterName"
										@change="Changetable1( scope.row,scope.$index)">
										<el-option v-for="item2 in itemdate" :key="item2.FItemID" :value-key="item2.FNumber"
											:label="item2.FNumber" :value="item2.FItemID">
											<span style="float: left">{{ item2.FNumber }}</span>
											<span style="float: right; color: #8492a6; font-size: 13px">{{
									                    item2.FName
									            }}</span>
										</el-option>
										<el-option v-if="itemdate.length === 30 && goodsBrandList.length > 30" value="tip" disabled>
										<span class="gray">--只展示前30条数据，更多数据请输入查询--</span>
									</el-option>
									</el-select>
									<!-- <span class="el-input__suffix" v-model="scope.row.Characteristic"
										@click="handleEdit13(scope,item,scope.$index, scope.row,item)"><span
											class="el-input__suffix-inner"><i
												class="el-select__caret el-input__icon el-icon-plus is-reverse" style=""></i>
										</span> -->
									</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="Name" label="物料名称" >
								<!-- <template slot-scope="scope" >
								<span>
									<el-input size="small" v-model="scope.row.Name" :controls="false">
									</el-input>
								</span>
							</template> -->
						</el-table-column>
						<el-table-column align="center"  prop="model" label="物料规格" >
								<!-- <template slot-scope="scope" >
								<span>
									<el-input size="small" v-model="scope.row.Name" :controls="false">
									</el-input>
								</span>
							</template> -->
						</el-table-column>
						<el-table-column align="center"  prop="Funity" label="计量单位">
							<template slot-scope="scope">
								<span class="demo-ruleForm">
									<el-select v-model="scope.row.Funity" clearable filterable placeholder=" "
										style="display: block;" size="small"
										:filter-method="filterName">
										<el-option v-for="item in untydate" :key="item.FUnitID" :value-key="item.FUnitID"
											:label="item.UnitName" :value="item.FUnitID">
											<span style="float: right; color: #8492a6; font-size: 13px">{{
									                    item.UnitName
									            }}</span>
										</el-option>
									</el-select>
									</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="FQty" label="采购数量">
							<template slot-scope="scope" >
								<span >
									<el-input-number size="small" v-model="scope.row.FQty" :precision="2"
										:controls="false">
									</el-input-number>
								</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="FKQty" label="采购数量">
							<template slot-scope="scope" >
								<span >
									<el-input-number size="small" v-model="scope.row.FKQty" :precision="2"
										:controls="false">
									</el-input-number>
								</span>
							</template>
						</el-table-column>
						</el-table>
						<div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="UpdateData.length">
							</el-pagination>
						</div>
						<div style="float: center; padding-top: 50px;">
					<el-row slot="footer" type="flex" justify="center">
						<el-col :span="6">
							<el-button type="primary" size="small" @click.once="btnPermOK()">确定</el-button>
							<el-button size="small" @click="btnPermCancel()">关闭</el-button>
						</el-col>
					</el-row>
				</div>
	           </el-dialog>
					<div  v-if='showtable'>
						<el-button v-for="(item, index) in btnArray" :key="item.id"
							:class="{ active: currentSorts == index }" @click="giveCharData1(index)" size="small">
							{{ item.text }}
						</el-button>
						<div  v-if='currentSorts==0'>
							<!-- <el-button type="primary" style="float:right;margin-left:2px" @click="unstatus()">反审核</el-button>
							<el-button type="primary" style="float:right" @click="status()">审核</el-button>
							<el-select v-model="treesID" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;">
					        	<el-option v-for="item in ctreesdata" :key="item.FItemID" :value-key="item.FItemID"
					        		:label="item.FName" :value="item.FItemID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select> -->
						 <el-table ref="multipleTable" :data="listData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" border id="el-table" highlight-current-row    v-loading="loading" 
						 element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;" class="demo-ruleForm">
             <el-table-column align="center"  prop="FBillNo" label="单据编号" class="demo-ruleForm" >
						</el-table-column>
						<el-table-column align="center"  prop="FDate" label="单据日期" class="demo-ruleForm" >
						</el-table-column>
						<el-table-column align="center"  prop="FDepartment" label="部门" class="demo-ruleForm" >
							<template slot-scope="scope">
								<span class="demo-ruleForm">
									<el-select v-model="scope.row.FDepartment" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;" disabled>
					        	<el-option v-for="item in Departmentdata" :key="item.FItemID" :value-key="item.FItemID"
					        		:label="item.FName" :value="item.FItemID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select>
								</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="FBiller" label="制单人" class="demo-ruleForm" >
							<template slot-scope="scope">
								<span class="demo-ruleForm">
									<el-select v-model="scope.row.FBiller" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;" disabled>
					        	<el-option v-for="item in userdata" :key="item.FUserID" :value-key="item.FUserID"
					        		:label="item.FName" :value="item.FUserID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select>
								</span>
							</template>
						</el-table-column>
					<el-table-column fixed="right" label="操作" width="100">
					<template slot-scope="scope">
						<el-button @click="spear(scope.row)" type="text" size="small" :disabled='scope.row.FYQty>0'>修改</el-button>
					</template>
					</el-table-column>
				    </el-table>
						<div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="listData.length">
							</el-pagination>
						</div>
						</div>
					<div  v-if='currentSorts==1'>
						<div>
							<el-upload ref="upload"
						   :show-file-list="false"
						   :on-change="uploadByJsqd"
						   :auto-upload="false"
						   :limit="1"
						   :action="'/api/xxxx/xxxxxxxxxxxxx/'"
						   accept=".xlsx"
						   style="float:left;margin-left:5px;">
					<el-button type="small"
					style="float:left;margin-left:5px;"
							   class=".el-dropdown-menu__item i"
							   slot="trigger"
							   icon="el-icon-download">导入</el-button>
							  
				</el-upload>
							<el-button type="primary" style="float:right;margin-right:5px;" @click="insert()">保存</el-button>
						<el-select v-model="treeID" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;">
					        	<el-option v-for="item in ctreedata" :key="item.FName" :value-key="item.FName"
					        		:label="item.FName" :value="item.FName">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select>
						</div>
						
							<el-card style="width:100%;margin-top:5px">
							<el-form :inline="true" :model="formInline" class="demo-form-inline">
								<el-form-item label="单据编号">
									<el-input v-model="formInline.BIllNo" placeholder="单据编号"></el-input>
								</el-form-item>
								<el-form-item label="单据日期">
									<el-date-picker
									v-model="formInline.value1"
									type="date"
									 format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
									placeholder="选择日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="部门">
								<el-select v-model="DepartmentID" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;">
					        	<el-option v-for="item in Departmentdata" :key="item.FItemID" :value-key="item.FItemID"
					        		:label="item.FName" :value="item.FItemID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select>
								</el-form-item>
								<el-form-item label="制单人">
									<el-select v-model="formInline.user" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;" disabled>
					        	<el-option v-for="item in userdata" :key="item.FUserID" :value-key="item.FUserID"
					        		:label="item.FName" :value="item.FUserID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select>
								</el-form-item>
							</el-form>
			           <el-table ref="multipleTable" :data="listSData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" border id="el-table" highlight-current-row    v-loading="loading" 
						 element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;" class="demo-ruleForm">
						 <el-table-column align="center" width="50" >
							 <el-tooltip class="item" effect="dark" content="新增行" placement="top-start" style="margin-top:5px">
						<el-button @click="naadd() " size="small" type="primary" icon="el-icon-plus" circle plain>
						</el-button>
						</el-tooltip>
						</el-table-column>
						<el-table-column align="center" sortable prop="Number" label="物料编码" >
								<template slot-scope="scope">
								<span class="demo-ruleForm">
									<el-select v-model="scope.row.Number" clearable filterable placeholder=" "
										style="display: block;" size="small"
										:filter-method="filterName"
										@change="Changetable( scope.row,scope.$index)">
										<el-option v-for="item2 in itemdate" :key="item2.FItemID" :value-key="item2.FNumber"
											:label="item2.FNumber" :value="item2.FItemID">
											<span style="float: left">{{ item2.FNumber }}</span>
											<span style="float: right; color: #8492a6; font-size: 13px">{{
									                    item2.FName
									            }}</span>
										</el-option>
										<el-option v-if="itemdate.length === 30 && goodsBrandList.length > 30" value="tip" disabled>
										<span class="gray">--只展示前30条数据，更多数据请输入查询--</span>
									</el-option>
									</el-select>
									<!-- <span class="el-input__suffix" v-model="scope.row.Characteristic"
										@click="handleEdit13(scope,item,scope.$index, scope.row,item)"><span
											class="el-input__suffix-inner"><i
												class="el-select__caret el-input__icon el-icon-plus is-reverse" style=""></i>
										</span> -->
									</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="Name" label="物料名称" >
								<!-- <template slot-scope="scope" >
								<span>
									<el-input size="small" v-model="scope.row.Name" :controls="false">
									</el-input>
								</span>
							</template> -->
						</el-table-column>
						<el-table-column align="center"  prop="model" label="物料规格" >
								<!-- <template slot-scope="scope" >
								<span>
									<el-input size="small" v-model="scope.row.Name" :controls="false">
									</el-input>
								</span>
							</template> -->
						</el-table-column>
						<el-table-column align="center"  prop="unty" label="计量单位">
							<template slot-scope="scope">
								<span class="demo-ruleForm">
									<el-select v-model="scope.row.unty" clearable filterable placeholder=" "
										style="display: block;" size="small"
										:filter-method="filterName">
										<el-option v-for="item in untydate" :key="item.FUnitID" :value-key="item.FUnitID"
											:label="item.UnitName" :value="item.FUnitID">
											<span style="float: right; color: #8492a6; font-size: 13px">{{
									                    item.UnitName
									            }}</span>
										</el-option>
									</el-select>
									</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="QTY" label="采购数量">
							<template slot-scope="scope" >
								<span >
									<el-input-number size="small" v-model="scope.row.QTY" :precision="2"
										:controls="false">
									</el-input-number>
								</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="KQTY" label="库存数量">
							<template slot-scope="scope" >
								<span >
									<el-input-number size="small" v-model="scope.row.KQTY" :precision="2"
										:controls="false">
									</el-input-number>
								</span>
							</template>
						</el-table-column>
						</el-table>
						<div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="listSData.length">
							</el-pagination>
						</div>
							</el-card>
						</div>
						<el-row :gutter="20" style="margin-top: 10px">
						</el-row>
					</div>
			      </el-card>
      </div>      	 
</template>
<script>
import {
		deptList,
		deptSave,
		deptDelete,
		login,
		GetLB,
		accountset,
		LinkQueryApp,
		LinkUpNextApp,
		PlugInApp,
		OperateBill
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	import axios from 'axios';
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
export default {
data() {
      return {
		 courseID: '',
		 DepartmentID:'',
		 Departmentdata:[],
		 userdata:[],
		 untydate:[],
		 module:'',
		 UpdateData:[],
		 dialogFormVisible:false,
		 FID:'',
		 formInline:{
			 user:'',
			 BIllNo:'',
			 value1:''
		 },
		 formInline1:{
			 user:'',
			 BIllNo:'',
			 value1:'',
			 DepartmentID:''
		 },
				    labId: '',
				    iconList: [],
					  formLabelWidth: '120px',
				      treeData: [
				      ],
					  props: {
							label: 'name',
							children: 'zones'
						  },
					  addform: {
						LCode: '',
						LItemID: '',
						LLevel: '',
						region: '',
					  },
					  count: 1,
					  btnArray: [{
					  		id: "1",
					  		text: "清单查看"
					  	}, {
					  		id: "2",
					  		text: "清单录入"
					  	}
					  ],
					  itemdate:[],
					  currentSorts:0,
					  showtable:false,
					  listSData:[],
					  listData:[],
					  currentPage:1,
					  pageSize:10,
					  projectID:'',
					  navMenuAdd:false,
					  serice:[],
					  nodedata:'',
					  resolvedata:'',
					  loading: true,
					  check:'',
					  checktreedata:'',
					  treeID:'',
					  ctreedata:[],
					  treesID:'',
					  ctreesdata:[],
					  v_str_AccountID:'154',
					  goodsBrandList:""
            }
			},
		created() {
			this.getdata()
		},
		mounted() {
		   // this.initPic()
		},
	
		methods: {
	   uploadByJsqd(file) {
       var reader = new FileReader(); //启动读取指定的File 内容
	   reader.readAsArrayBuffer(file.raw); //当读取操作完成时,会触发一个 load 事件,从而可以使用 reader.onload 属性对该事件进行处理。
	console.log(file)
	reader.onload = e => {        //获取文件数据
		const data = e.target.result; //XLSX读取文件
		const wb = XLSX.read(data, { type: "array" });  //获取第一张表
		const wsname = wb.SheetNames[0];
		const ws = wb.Sheets[wsname];
		var result = XLSX.utils.sheet_to_json(ws, { header: 1 });
		this.$refs.upload.clearFiles(); //清除当前 files
		if (result.length < 1503) {
			this.dataDetail(result);
		} else {
			this.$message("每次导入数据最多1500条");
		}
		return result;
	   };
      },
	  async dataDetail(result) {
		  let att=[]
		  this.listSData=[];
		  for(let i=1;i<result.length;i++){
			  let item=result[i]
			 // this.formInline.value1=item['0'];
			 let obj;
			if(item.length>0){
			  obj = this.Departmentdata.find(function (e) {
				    return e.FName=== item['0']
				})
			}else{
				continue;
			}
			
			if(obj ==undefined){
					this.$message({
					type: 'error',
					message: '部门名称错误'
					});
			}else{
			  this.DepartmentID=obj.FItemID;
			  let objuser = this.userdata.find(function (e) {
				    return e.FName=== item['1']
				})
				console.log(objuser,this.userdata,item['1'])
			  this.formInline.user=objuser.FUserID;
			  att.push({'Number':item['2'],'unty':item['4'],QTY:item['5'],KQTY:item['6']})
			  let moo={'Number':item['2'],'unty':item['4'],QTY:item['5'],KQTY:item['6']}
			  this.listSData.push({
					Name:'',
					unty:'',
					QTY:'',
					KQTY:''
			  })
			  let index=i-1
			  this.Changetablep(moo,index)
			}
		  }
		//   console.log(att)
		//   this.listSData=att
	  },
	  Changetablep(row,index){
				let obj = this.goodsBrandList.find(function (e) {
				    return e.FNumber=== row.Number
				})
				console.log(obj,row,this.goodsBrandList)
				let poi=new Array();
				poi.push(obj)
				this.itemdate=poi
				this.listSData[index].Number=obj.FItemID
				this.listSData[index].QTY=row.QTY
				this.listSData[index].KQTY=row.KQTY
				let phems = {
					v_str_AccountID: this.v_str_AccountID,
						jsSQL: "{\"SQL\":[{\"select\":\"select * from  v_BASE_ICItem  where FItemID='"+obj.FItemID+"'\"}]}"
				}
				login(phems).then(data => {
					console.log(data)
					let  arr = data.Data.Table 
					this.untydate=arr
					this.unty=arr[0].FUnitID
					this.listSData[index].unty=arr[0].FUnitID
					this.listSData[index].model=arr[0].FModel
				})
		        //console.log(obj,this.itemdate,row)
				this.listSData[index].Name=obj.FName
			},
			Changetable(row,index){
				let obj = this.goodsBrandList.find(function (e) {
				    return e.FItemID=== row.Number
				})
				let phems = {
					v_str_AccountID: this.v_str_AccountID,
						jsSQL: "{\"SQL\":[{\"select\":\"select * from  v_BASE_ICItem  where FItemID='"+obj.FItemID+"'\"}]}"
				}
				login(phems).then(data => {
					console.log(data)
					let  arr = data.Data.Table 
					this.untydate=arr
					this.unty=arr[0].FUnitID
					this.listSData[index].unty=arr[0].FUnitID
					this.listSData[index].model=arr[0].FModel
				})
		        console.log(obj,this.itemdate,row)
				this.listSData[index].Name=obj.FName	
			},
			Changetable1(row,index){
				let obj = this.goodsBrandList.find(function (e) {
				    return e.FItemID=== row.FMaterialID
				})
				let phems = {
					v_str_AccountID: this.v_str_AccountID,
						jsSQL: "{\"SQL\":[{\"select\":\"select * from  v_BASE_ICItem  where FItemID='"+obj.FItemID+"'\"}]}"
				}
				login(phems).then(data => {
					console.log(data)
					let  arr = data.Data.Table 
					this.untydate=arr
					this.unty=arr[0].FUnitID
					this.UpdateData[index].model=arr[0].FModel
				})
		        console.log(obj,this.itemdate,row)
				this.UpdateData[index].Name=obj.FName
			},
			// 自定义搜索方法
			filterName(query) {
				const list = this.goodsBrandList.filter(item => {
				return item.FNumber && item.FNumber.includes(query)
				})
				// 根据检索条件筛选出来的选项，只取前30条
				if (list.length > 30) {
				this.itemdate = list.slice(0, 30)
				} else {
				this.itemdate = list
				}
			},
			naadd(){
				this.listSData.push({
					Name:'',
					unty:'',
					QTY:'',
					KQTY:''
				})
			},
			ainsert(){
				this.UpdateData.push({
					FMaterialID:'',
					Funity:'',
					FQty:'',
					FKQty:''	
				})
			},
			adelete(row,index){
               //console.log(row,index)
			   var new_arr = this.UpdateData.splice(index, 1)
			},
		async	btnPermOK(){
			let entry='',FID;
			for(let index=0;index<this.UpdateData.length;index++){
			 let item=this.UpdateData[index];
				FID=this.FID
				let FIndex=Number(index)+1
				if(index!=this.UpdateData.length-1){
                entry+="("+"'"+FID+"',"+"'"+FIndex+"',"+"'"+item.FMaterialID+"',"+"'"+item.FQty+"',"+"'"+item.FKQty+"',"+"'"+item.Funity+"'),"
			   }else{
			   entry+="("+"'"+FID+"',"+"'"+FIndex+"',"+"'"+item.FMaterialID+"',"+"'"+item.FQty+"',"+"'"+item.FKQty+"',"+"'"+item.Funity+"')"	
			  }
			}
				console.log(entry,FID,this.UpdateData)
				let dlet={
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\"delete  from YP_ProjectEntry where FID='"+FID+"' \"}]}"
				}
				let delt= await login(dlet)
				let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" update YP_project set FDate='"+this.formInline1.value1+"',FDepartment= '"+this.formInline1.DepartmentID+"' where FID='"+FID+"';insert into YP_ProjectEntry (FID,FIndex,FMaterialID,FQty,FKQty,Funity) values "+entry+";\"}]}"
				 }
          login(phems).then(data => {
					if(data.Result=='Y'){
					this.$message({
					type: 'success',
					message: '修改成功'
					});
					this.getlistdata()
					}
				})
			},
			btnPermCancel(){
				this.dialogFormVisible=false
			},
			giveCharData1(index) {
				if (this.currentSorts === index) {
					return false;
				}
				console.log(this.currentSorts,index)
				this.currentSorts = index;
			},
			checkBox(){
				let checkdata=this.$refs.lazytree.getCheckedNodes();
				let arr=[]
				this.removeByValue(checkdata,undefined)
				console.log(checkdata)
				this.checktreedata=checkdata
                checkdata.forEach(item=>{
					if(item.children==undefined){
						arr.push(item)
					}
				})
                this.ctreedata=arr
				let apo=JSON.parse(JSON.stringify(arr));
				apo.unshift({
					FItemID:'all',
					FName:'全部'
				})
				this.ctreesdata=apo
				this.getlistdata();
			},
			removeByValue(arr,val){
				for(let  i=0;i<arr.length;i++){
					if(arr[i]==val){
						arr.splice(i,1)
						break
					}
				}
			},
		async	getlistdata(){
				let ID='';
				this.checktreedata.forEach( (item,index) =>{
                  if(index!=this.checktreedata.length-1){
					  ID+="'"+item.FName+"' ,"
				  }else{
					  ID+="'"+item.FName+"'"
				  }
				})
				let phems = {
					v_str_AccountID: this.v_str_AccountID,
				    jsSQL: "{\"SQL\":[{\"select\":\"select * from  v_project  where Fproject in ("+ID+") and FMModuel='"+this.projectID+"'  order by FDate desc\"}]}"
				}
				let phemsm = {
					'v_str_AccountID': this.v_str_AccountID,
					'v_str_No': "103",
					'v_str_Parameter':"{\"Filter\":[{\"FBillType\":\"200000002\",\"FAccountNum\":\"05\"}]}"
				}
				let ret=await PlugInApp(phemsm)
			    this.formInline.BIllNo=ret.Data
				login(phems).then(data => {
					let  arr = data.Data.Table 
					if(arr.length==0){
						this.listData=[]
					}else{
						this.listData=arr
					}
				
				})
			},
			handleSizeChange(val) {
				this.pagesize = val;
			},
			handleCurrentChange(val) {
				this.currentPage = val;
			},
		async insert(){
			  let values='',entry="";
			  // if()
			    let mpo= {
				 	v_str_AccountID: this.v_str_AccountID,
				 	jsSQL: "{\"SQL\":[{\"exec\":\"select * from ICMaxNum where FTableName='YP_project';exec GetICMaxNum @TableName=YP_project,@FInterID=0,@UserID="+this.formInline.user+"\"}]}"
				 }
				//console.log(this.listSData) 
				//let FID='0'
				let rem =await login(mpo)
				//console.log(rem)
				let FID=rem.Data.Table[0].FMaxNum
				this.listSData.forEach((item,index)=>{
					let FIndex=Number(index)+1
					if(index!=this.listSData.length-1){
                     entry+="("+"'"+FID+"',"+"'"+FIndex+"',"+"'"+item.Number+"',"+"'"+item.QTY+"',"+"'"+item.KQTY+"',"+"'"+item.unty+"'),"
					}else{
					 entry+="("+"'"+FID+"',"+"'"+FIndex+"',"+"'"+item.Number+"',"+"'"+item.QTY+"',"+"'"+item.KQTY+"',"+"'"+item.unty+"')"	
					}
				})
				console.log(entry)
				let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" insert into YP_project (FID,FClassTypeID,FBillNo,FDate,FBiller,FMModuel,Fproject,FDepartment) values ('"+FID+"','200000002','"+this.formInline.BIllNo+"','"+this.formInline.value1+"','"+this.formInline.user+"','"+this.projectID+"','"+this.treeID+"', '"+this.DepartmentID+"');\"}]}"
				 }
				if(this.treeID!=''){
                  login(phems).then(data => {
					if(data.Result=='Y'){
						let pppl= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" insert into YP_ProjectEntry (FID,FIndex,FMaterialID,FQty,FKQty,Funity) values "+entry+";\"}]}"
				 }
				 login(pppl).then(rtt=>{
					 if(rtt.Result=='Y'){
					 this.$message({
					type: 'success',
					message: '保存成功'
					});
					this.formInline.value1='';
					this.DepartmentID='';
					this.listSData=[{
					Name:'',
					unty:'',
					QTY:'',
					kQTY:''
				}]
					this.getlistdata()
					 }else{
						 this.$message({
					type: 'error',
					message: '保存失败'
					});
					 }
				 })
					//this.formInline.user='';
					}
				})
				}else{
					this.$message({
					type: 'error',
					message: '请选择保存进的模快'
					});
				}	
			},
			
		async	spear(row){
				console.log(row)
				this.formInline1.BIllNo=row.FBillNo
				this.formInline1.DepartmentID=row.FDepartment
				this.formInline1.user=row.FBiller
				this.formInline1.value1=row.FDate
				let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  v_Project  where FID='"+row.FID+"'\"}]}"
				}
				let data=await login(phems)
				this.UpdateData=data.Data.Table
                this.FID=this.UpdateData[0].FID
				this.UpdateData.forEach((item,index)=>{
	               this.Changetable1(item,index)
				})
				this.dialogFormVisible=true;
			},
			getdata(){
				let arr;
				let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  t_Item  where FItemClassID='3005'\"}]}"
				}
				login(phems).then(data => {
				arr = data.Data.Table
				console.log(arr)
				let treedata=new Array()
				let att=this.convert(arr)
				this.treeData=att
				})
			},
			convert(list) {
			    let res = []
			    let maps = list.reduce((pre, cur) => { pre[cur.FItemID] = cur; return pre }, {}) 
			    // let maps = new Map(Array.from(list, (x) => [x.id, x])) 
			    for(let i = 0, len = list.length; i < len; i++ ) {
			        let item = list[i]
					item['label']=item['FName']
			        if(item.FParentID === 0) {
			            res.push(item)
			        } else {
			        let parent = maps[item.FParentID]
			        // let parent = maps.get(item.parentId)
			  		console.log(parent)
			        if (parent) {
			          (parent.children || (parent.children = [])).push(item);
			        }
			        }
			    }
			 return res
			},
			convertt(list) {
			   let res = []
			     let maps = list.reduce((pre, cur) => { pre[cur.FItemID] = cur; return pre }, {}) 
			     // let maps = new Map(Array.from(list, (x) => [x.id, x])) 
			     for(let i = 0, len = list.length; i < len; i++ ) {
			         let item = list[i]
			         if(item.FParentID === 0){
			             res.push(item)
			         } else {
			             let parent = maps[item.FParentID]
			             // let parent = maps.get(item.parentId)
						 //console.log(parent)
			         if (parent) {
			           (parent.children || (parent.children = [])).push(item);
			         }
			         }
			     }
			     return res
			},
			navMenuOK(){
				let LName=this.addform.LName,LItemID=this.addform.LItemID,ID=this.projectID
				let that=this
				let phems = {
						v_str_AccountID: this.v_str_AccountID,
						jsSQL: "{\"SQL\":[{\"insert\":\"insert into  YP_module (FName, FParentID, FProjectID) VALUES ('"+LName+"', '"+LItemID+"', '"+ID+"')\"}]}"
				}
				login(phems).then(data => {
                    if(data.Result =='Y'){
						that.$message({
							type: 'success',
							message: '新增成功'
						});
						let atu=[];
						console.log(that.nodedata)
						that.nodedata.childNodes = [] 
						that.loadNode(that.nodedata,that.resolvedata)
					}else{
						that.$message({
							type: 'error',
							message: '新增失败'
						});
					}
				})
				this.navMenuAdd=false
			},
			  handleCheckChange(data, checked, indeterminate) {
			      //   console.log(data, checked, indeterminate);
					 this.check=checked
			  },
			  handleNodeClick(data) {
			        // console.log(data);
				   },
				sumArr(arr){
				var sum = 0
				arr.forEach(item => {
					if(item.children) {
						sum += this.sumArr(item.children); //递归去处理数组元素
					} else {
						sum+=Number(item.FSumMoney) 
					}
				})
				return sum
				},
			  loadNode(node, resolve,tu) {
					let ID=this.projectID,arr='';
					let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  YP_module  where FProjectID='"+ID+"'\"}]}"
				}
				login(phems).then(data => {
					arr = data.Data.Table
					arr.forEach(item =>{
						item['name']=item['FName']
					})
					let att=this.convertt(arr)
					console.log(att)
					if (node.level === 0) {
					this.nodedata=node,
					this.resolvedata=resolve
					return resolve(att);
				}
			    setTimeout(() => {
			       var data;
					   if(node.data.children){
						   data=node.data.children
					   }else{
						   data=[]
					   } resolve(data);
			      }, 500);
				})
			},
		async	nodeClick(e){
					let user = JSON.parse(localStorage.getItem('userdata'))
					this.formInline.user=user[0].FUserID
					this.projectID=e.FItemID
					this.module=e.FName
					let atu=[];
					if(this.nodedata!=''){
						 this.nodedata.childNodes = [] ;
						 this.loadNode(this.nodedata,this.resolvedata)
					}
					console.log(this.module)
					if(e.children==undefined){
						this.showtable=true
					}else{
						this.$message({
							type: 'error',
							message: '当前项目不是末级，请检查'
						});
						this.showtable=false
					}
					let arr,that=this;
					let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  t_ICItemCore ;select * from  t_Department;select * from  t_User\"}]}"
				}
				
				login(phems).then(data => {
                arr = data.Data.Table
				this.Departmentdata=data.Data.Table1
                this.userdata=data.Data.Table2
				that.loading = false
				this.goodsBrandList =arr
				that.itemdate=arr.slice(0, 30)
				 this.ctreedata=[]
				that.listSData=[{
					Name:'',
					unty:'',
					QTY:'',
					kQTY:''
				}]
				
				})
				
					
				},
		},
}
</script>

<style>
		.demo-ruleForm>>>.el-input {
		    width: 100%;
		    margin-right: 10px;
		}
		.demo-ruleForm>>>.el-input__inner {
			border: 0;
			background-color:
				#FFF;
			color: #606266;
			/*text-align: center;*/
		}
		.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
			margin-left: 0px
		}
		 .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>

 


// WEBPACK FOOTER //
// src/views/system/Variable.vue